import {
    GET_CUSTOMERS_SUCCESS,
    GET_CUSTOMERS_FAIL,
    ADD_NEW_CUSTOMER_SUCCESS,
    ADD_NEW_CUSTOMER_FAIL,
    UPDATE_CUSTOMER_SUCCESS,
    UPDATE_CUSTOMER_FAIL,
    DELETE_CUSTOMER_SUCCESS,
    DELETE_CUSTOMER_FAIL,
    GET_CUSTOMER_DETAIL_SUCCESS,
    GET_CUSTOMER_DETAIL_FAIL,
    GET_CUSTOMER_CATEGORIES_SUCCESS,
    GET_CUSTOMER_CATEGORIES_FAIL,
} from "./actionTypes"

const INIT_STATE = {
    customers: [],
    categories: [],
    customer: null,
    error: {},
    loading: false
}

const Customers = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_CUSTOMERS_SUCCESS:
            return {
                ...state,
                customers: action.payload,
            }

        case GET_CUSTOMER_CATEGORIES_SUCCESS:
            return {
                ...state,
                categories: action.payload,
            }

        case GET_CUSTOMER_CATEGORIES_FAIL:
        case GET_CUSTOMERS_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case GET_CUSTOMER_DETAIL_SUCCESS:
            return {
                ...state,
                customer: action.payload,
            }

        case GET_CUSTOMER_DETAIL_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case ADD_NEW_CUSTOMER_SUCCESS:
            return {
                ...state,
                customers: [action.payload, ...state.customers],
            }

        case UPDATE_CUSTOMER_SUCCESS:
            return {
                ...state,
                customers: state.customers.map(customer =>
                    customer.id.toString() === action.payload.id.toString()
                        ? action.payload
                        : customer
                ),
            }

        case DELETE_CUSTOMER_SUCCESS:
            return {
                ...state,
                customers: state.customers.filter(
                    customer => customer.id.toString() !== action.payload.toString()
                ),
            }

        case ADD_NEW_CUSTOMER_FAIL:
        case UPDATE_CUSTOMER_FAIL:
        case DELETE_CUSTOMER_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        default:
            return state
    }
}

export default Customers
